module.exports = __webpack_public_path__ + "img/copo.29352e97.png";